






















import { computed, defineComponent, ref } from "@vue/composition-api";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseIconButton from "@/components/BaseIconButton";
import CreatorsFiltersModal from "@/views/PageCreatorsList/components/CreatorsFiltersModal";

interface FiltersData {
  tagIds: string[];
  locations: UserLocation[];
  languages: string[];
}

type QueryValue = string | (string | null)[] | null | undefined;

const toArray = (value: QueryValue): string[] => {
  if (!value) return [];
  return (Array.isArray(value) ? value : [value]).filter((i): i is string => !!i);
};

/**
 * The filters of the home page live in the route query, so the page and this button stay in sync without a store
 */
export default defineComponent({
  name: "HomeFeedFilters",
  components: { BaseIconButton, CreatorsFiltersModal },
  setup(_, { root }) {
    const showFilters = ref(false);

    const tagIds = computed(() => toArray(root.$route.query.tag));
    const languages = computed(() => toArray(root.$route.query.language));
    const locations = computed<UserLocation[]>(() => toArray(root.$route.query.location).map(i => JSON.parse(i)));
    const showFiltersIndicator = computed(
      () => tagIds.value.length > 0 || languages.value.length > 0 || locations.value.length > 0
    );

    const onFiltersUpdate = async (data: FiltersData) => {
      showFilters.value = false;
      await root.$router.replace({
        name: "home",
        query: {
          tag: data.tagIds,
          language: data.languages,
          location: data.locations.map(i => JSON.stringify(i)),
        },
      });
    };

    return {
      showFilters,
      tagIds,
      languages,
      locations,
      showFiltersIndicator,
      onFiltersUpdate,
    };
  },
});
